<template>
  <div id="app">
    <AppLayout>
      <router-view />
    </AppLayout>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import network from "./utils/network";
import { newLogger } from "@/utils/util";

const logger = newLogger("App.VUE");

export default {
  title: "mp:page.default.title",
  components: {
    AppLayout: () => import("@/layouts/AppLayout.vue"),
  },
  async created() {
    network.configure(this.$store, this.$router);

    await this.fetchAllCountries();
    // this.setCountryById(1);

    await this.fetchPublicTokens();
    await this.fetchBnplInstanceType();
    await this.fetchInternalTokens();
  },
  async mounted() {
  },
  computed: {
    ...mapGetters({
      loggedIn: "session/isReady",
      country: "i18n/country",
      getBnplInstanceType: "uiConfigStore/getBnplInstanceType",
    }),
    routerLocale() {
      return this.$route.params.locale;
    },
    locale() {
      return this.country.languageIso;
    },
  },
  methods: {
    ...mapActions({
      fetchPublicTokensByLanguage: "i18n/fetchTokensByLanguage",
      fetchInternalTokensByLanguage: "i18n/fetchInternalTokensByLanguage",
      loadTokensByLanguage: "i18n/fetchInternalTokensByLanguage",
      fetchAllCountries: "i18n/fetchAllCountries",
      fetchBnplInstanceType: "uiConfigStore/fetchBnplInstanceType",
      fetchIsLimit: "customerLimit/fetchIsLimit",
    }),
    ...mapMutations({
      setCountryById: "i18n/setCountryById",
    }),
    async fetchPublicTokens() {
      try {
        await this.fetchPublicTokensByLanguage(this.locale);
      } catch (ex) {
        logger.error(ex);
        logger.error("Public Token fetch failed!");
        setTimeout(() => this.fetchPublicTokens(), 1000);
      }
    },
    async fetchInternalTokens() {
      if (this.$store.getters["session/isReady"]) {
        try {
          await this.fetchInternalTokensByLanguage(this.locale);
        } catch (ex) {
          logger.error(ex);
          logger.error("Internal Token fetch failed!");
          this.retryInternalTokens();
        }
      } else {
        this.retryInternalTokens();
      }
    },
    retryInternalTokens() {
      setTimeout(() => this.fetchInternalTokens(), 1000);
    },
    async fetchAutoloadConfigs() {
      try {
        await this.fetchAutoloadConfigsFromStore();
      } catch (ex) {
        logger.error(ex);
        logger.error("Autoload config fetch failed!");
        setTimeout(() => this.fetchAutoloadConfigs(), 1000);
      }
    },
  },
  watch: {
    locale: {
      async handler() {
        await this.fetchPublicTokens();
        await this.fetchInternalTokens();
      },
      // immediate: true,
    },
  },
};
</script>
